export default "__VITE_ASSET__Bn6WJTE9__"